import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';

import imlogo from '../../Images/headerImages/IM Logo white.png';
import moneyicon from '../../Images/headerImages/money-icon.svg';
import menuIcon from '../../Images/headerImages/menu-icon.svg';
import ArrowIcon from '../../Images/headerImages/filterDropdown.svg'; 

const headerStyle = {
    background: '#30318C',
    height: '45px', 
    overflow: 'visible',
    position:'fixed',
    top:'0',
    left:'0',
    zIndex:'110',
    width:'100%'
};

const logoStyle = {
    marginTop: '5px',
    marginLeft: '10px',
    maxWidth: '130px',
};

const moneyIconStyle = {
    float: 'right',
    marginTop: '5px',
    marginRight: '15px',
    width: '36px',
    height: '31px',
};

const menuIconStyle = {
    float: 'right',
    marginTop: '5px', marginRight: '15px', height: '32px', width: '32px'
}

const usernameStyle = {
    float: 'right',
    marginTop: '10px',
    marginRight: '15px',
    color: '#fff',
};


class HeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
          isDropdownVisible: false, username : 'Hi,  User',
          showAppPage:false
        };
      }
    
      toggleDropdown = (event) => {
        event.stopPropagation();
        this.setState((prevState) => ({
          isDropdownVisible: !prevState.isDropdownVisible,
        }));
      };

      userStatus(glid){
        return new Promise((resolve) => {
            var showAppPage = false;
    
            var host = window.location.hostname;
    
            var statusUrl = host == 'loans.indiamart.com' ? 'https://loans.indiamart.com/functions.php' : 'https://dev-loans.indiamart.com/functions.php';
    
            var statusData = {
                "functionName": "checkStatus",
                "glid": glid,
            };
    
            var formData = new FormData();
            for (var key in statusData) {
                formData.append(key, statusData[key]);
            }
    
            axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: statusUrl,
                data: statusData,
                timeout: 10000
            }).then((response) => {
                //console.log("response in header=> ",response['data']);
                if (response['data'] == true) {
                    //console.log("showAppPage setting true");
                    showAppPage = true;
                }
                //console.log("Finally showAppPage in header=> ", showAppPage);
                resolve(showAppPage);
            }).catch(error => {
                console.error("Error occurred: ", error);
                // Resolve with false if an error occurs
                resolve(false);
            });
        });
    }


    async componentDidMount() {
        const cookie = new Cookies();

        var visitor_name = '', glid = '';

        let visitorData = cookie.get('ImeshVisitor');
        if (visitorData) {
            visitorData = visitorData.split("|");

            let sd = [];
            visitorData.map((data) => {
                sd = data.split("=")
                if (sd[0] == "fn") {
                    visitor_name = sd[1]
                }
                if (sd[0] == "glid") {
                    glid = sd[1]
                }
            })
        }

        if (glid) {
            try {
                // Fetch user
                const flag = await this.userStatus(glid);
                this.setState({ showAppPage: flag });
                //console.log("In header comp");
            } catch (error) {
                console.error("Error fetching user status: ", error);
                // Handle error//
            }
        }


        if (visitor_name) {
            this.setState({username : 'Hi, ' + visitor_name});
        }

        if (navigator.userAgent.includes("IM-Android")) {
            document.getElementById("im_header").style.backgroundColor = "#00a699";
        }
    }

    handleclick = (e) => {
        e.stopPropagation();
    }

    handleLogoClick = () => {
        this.gatrack('LOANS HomePage','IM Logo','Click');
    }

    gatrack(category, action, label) {
        window.imgtm.push({ 'event': 'IMEvent', 'eventCategory': category, 'eventAction': action, 'eventLabel': label});
    }

    render() {
        return (
            <>
                <header id="im_header" style={headerStyle}>
                    <div className="container" style={{ maxWidth: '1297px', height: '40px' }}>
                        <div className="row" style={{ height: '100%' }}>
                            <div className="col-12" style={{ padding: '0' }}>
                                <div className="header" style={{ height: '100%' }}>
    
                                    {
                                        window.location.pathname === '/' ?
                                        <a href="https://indiamart.com/" target="_blank" onClick={this.handleLogoClick}>
                                            <img style={logoStyle} alt="im_logo" src={imlogo} />
                                        </a> :
                                        <a href="/">
                                            <img style={logoStyle} alt="im_logo" src={imlogo} />
                                        </a>
                                    }
    
                                    <div className="dropdown" style={{ float: 'right', marginTop: '5px' }}>
                                        <img
                                            src={menuIcon}
                                            alt="logo"
                                            style={{ width: '32px', height: '32px', cursor: 'pointer' }}
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        />
    
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            {
                                                window.location.pathname === '/' ?
                                                <li><div className="dropdown-item" style={{ backgroundColor: '#E5E1E1', color: 'var(--IM-Black, #1B1D1D)' }} onClick={(event) => { event.preventDefault(); event.stopPropagation(); }}>Home</div></li> :
                                                <li><a className="dropdown-item" href="/">Home</a></li>
                                            }

                                            {
                                                window.location.pathname === '/applications' ?
                                                <li><div className="dropdown-item" 
                                                style={{backgroundColor:'#E5E1E1',cursor:'not-allowed', color: 'var(--IM-Black, #1B1D1D)'}} onClick={(event)=>{event.preventDefault(); event.stopPropagation();}}>Your Applications</div></li> :
                                                this.state.showAppPage && <li><a className="dropdown-item" href="/applications">Your Applications</a></li>
                                            }
    
                                            {
                                                window.location.pathname === '/about' ?
                                                <li><div className="dropdown-item" style={{ backgroundColor: '#E5E1E1', cursor: 'not-allowed', color: 'var(--IM-Black, #1B1D1D)' }} onClick={(event) => { event.preventDefault(); event.stopPropagation(); }}>About Us</div></li> :
                                                <li><a className="dropdown-item" href="/about">About Us</a></li>
                                            }
    
                                            {
                                                window.location.pathname === '/product' ?
                                                <li><div className="dropdown-item" style={{ backgroundColor: '#E5E1E1', cursor: 'not-allowed', color: 'var(--IM-Black, #1B1D1D)' }} onClick={(event) => { event.preventDefault(); event.stopPropagation(); }}>Our Products</div></li> :
                                                <li><a className="dropdown-item" href="/product">Our Products</a></li>
                                            }
    
                                            <li className="ourPartnersDropdown" onClick={this.toggleDropdown}>Our Partners <img src={ArrowIcon} /></li>
    
                                            {this.state.isDropdownVisible && (
                                                <div onClick={(event) => event.stopPropagation()}>
                                                    <ul style={{ listStyle: 'none', padding: '0px' }}>
                                                        {/* {
                                                            window.location.pathname === '/partner/oneinfinity' ?
                                                            <li><div className="dropdown-item2" style={{ backgroundColor: '#E5E1E1' }}>OneInfinity</div></li> :
                                                            <li><a className="dropdown-item2" href="/partner/oneinfinity">OneInfinity</a></li>
                                                        } */}
    
                                                        {
                                                            window.location.pathname === '/partner/loantap' ?
                                                            <li><div className="dropdown-item2" style={{ backgroundColor: '#E5E1E1' }}>LoanTap</div></li> :
                                                            <li><a className="dropdown-item2" href="/partner/loantap">LoanTap</a></li>
                                                        }
                                                        {
                                                            window.location.pathname === '/partner/iifl' ?
                                                            <li><div className="dropdown-item2" style={{ backgroundColor: '#E5E1E1' }}>IIFL</div></li> :
                                                            <li><a className="dropdown-item2" href="/partner/iifl">IIFL</a></li>
                                                        }
                                                        {
                                                            window.location.pathname === '/partner/icici' ?
                                                            <li><div className="dropdown-item2" style={{ backgroundColor: '#E5E1E1' }}>ICICI</div></li> :
                                                            <li><a className="dropdown-item2" href="/partner/icici">ICICI</a></li>
                                                        }
                                                        {/* {
                                                            window.location.pathname === '/partner/poonawalla' ?
                                                            <li><div className="dropdown-item2" style={{ backgroundColor: '#E5E1E1' }}>Poonawalla</div></li> :
                                                            <li><a className="dropdown-item2" href="/partner/poonawalla">Poonawalla</a></li>
                                                        } */}
                                                        {
                                                            window.location.pathname === '/partner/indifi' ?
                                                            <li><div className="dropdown-item2" style={{ backgroundColor: '#E5E1E1' }}>Indifi</div></li> :
                                                            <li><a className="dropdown-item2" href="/partner/indifi">Indifi</a></li>
                                                        }
                                                        {
                                                            window.location.pathname === '/partner/tatacapital' ?
                                                            <li><div className="dropdown-item2" style={{ backgroundColor: '#E5E1E1' }}>Tata Capital</div></li> :
                                                            <li><a className="dropdown-item2" href="/partner/tatacapital">Tata Capital</a></li>
                                                        }
                                                    </ul>
                                                </div>
                                            )}
                                        </ul>
                                    </div>
    
                                    <img style={moneyIconStyle} src={moneyicon} alt="moneyiconlogo" />
                                    <span id="username" style={usernameStyle}>{this.state.username}</span>
    
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
    
            </>
        );
    }
    

}


export default HeaderComponent;